import "react";
import { styled as e } from "styled-components";
import { jsx as t } from "react/jsx-runtime";
//#region src/components/Page/Page.tsx
var n = e.div`
    width: 100%;
    max-width: ${({ $maxWidth: e }) => e};
    margin-inline: auto;
`, r = ({ maxWidth: e = 1520, className: r, children: i }) => /* @__PURE__ */ t(n, {
	$maxWidth: typeof e == "number" ? `${e}px` : e,
	className: r,
	children: i
});
//#endregion
export { r as Page };
